export default {
  name: 'text-view',
  props: ['value', 'placeholder'],
  render() {
    return <el-input disabled vModel={this.value} placeholder={this.placeholder}></el-input>;
  },
};
